// extracted by css-extract-rspack-plugin
export default {"closeIcon":"Pk49V"};